import { render } from "./CreateForm.vue?vue&type=template&id=a6391a8e&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"

import "./CreateForm.vue?vue&type=style&index=0&id=a6391a8e&scoped=true&lang=css"
import "./CreateForm.vue?vue&type=style&index=1&id=a6391a8e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6391a8e"]])

export default __exports__